// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, boolean, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementCanvasesDataResult = objectOf({
  hits: number,
  has_post_launch_draft: boolean,
  count_active_cloneable_canvases: number,
  idle_count: number,
  results: arrayOf(
    objectOf({
      workflow_name: string,
      workflow_description: nullOrUndefined,
      id: string,
      version: string,
      app_group_id: string,
      enabled: boolean,
      currently_sending: boolean,
      created: objectOf({
        time: number,
        name: string,
        d_id: string,
      }),
      last_edit: objectOf({
        time: number,
        name: string,
        d_id: string,
      }),
      is_convertible: nullOrUndefined,
      conversion_errors: nullOrUndefined,
      is_archived: boolean,
      is_draft: boolean,
      tag_names: arrayOf(nullOrUndefined),
      territory_ids: arrayOf(nullOrUndefined),
      priority_bucket: number,
      priority: number,
      total_sent: number,
    })
  ),
});
